import { dashboardsPages } from "./menu/dashboardsPages";
import { opportunitiesPage } from "./menu/opportunitiesPage";
import { infrastructurePages } from "./menu/infrastructurePages";
import { performancePages } from "./menu/performancePages";
import { plannerPages } from "./menu/plannerPages";
import { healthPages } from "./menu/healthPages";
import { securityPages } from "./menu/securityPages";
import { adminConsolePages } from "./menu/admin_console";
import { enterpriseAdminPages } from "./menu/enterpriseAdminPages";
import { finOpsPages } from "./menu/finOpsPages";
import { configuration } from "./menu/configuration";

export const menuPages = [
  dashboardsPages,
  plannerPages,
  opportunitiesPage,
  performancePages,
  healthPages,
  infrastructurePages,
  securityPages,
  configuration,
  adminConsolePages,
  enterpriseAdminPages,
  // finOpsPages,
];

export const finOpsMenuPages = [
  finOpsPages,
  configuration,
  adminConsolePages,
  enterpriseAdminPages,
];
